export type UserModel = {
  name: string
  type: UserType
}

export enum UserType {
  COMMON = 'common',
  INVESTOR = 'investor'
}
